import enUS from "./en-US.json";
import zhTW from "./zh-TW.json";
import jaJP from "./ja-JP.json";

const locales = (locale) => {
  if (locale.includes("zh")) return zhTW;
  else if (locale.includes("en")) return enUS;
  else if (locale.includes("ja")) return jaJP;
  else return enUS;
};

export default locales;
